import {ModuleWithProviders, NgModule} from '@angular/core';
import {UserService} from './user/user.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { RouterModule } from '@angular/router';
import {ValidationService} from './validation/validation.service';
import {TagService} from './tag/tag.service';
import {AccountService} from './admin/account.service';
import {ItemService} from './item/item.service';
import {HelperService} from './core/helper.service';
import {RouterService} from './core/router.service';
import {BrowserStateInterceptor} from './core/browserstate.interceptor';
import {InboundNotificationService} from './core/inbound-notification.service';
import {MessageService} from './message/message.service';

@NgModule({
  imports: [HttpClientModule, RouterModule]
})
export class UfeServicesModule {
  public static forRoot(): ModuleWithProviders<UfeServicesModule> {
    return {
      ngModule: UfeServicesModule,
      providers: [UserService, ValidationService, TagService,
        AccountService, ItemService, HelperService, RouterService,
          InboundNotificationService, MessageService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: BrowserStateInterceptor,
          multi: true
        }
      ]
    };
  }
}
